import { supabase } from '../lib/supabase';

export interface AuthAuditEventPayload {
  details?: Record<string, unknown>;
  email?: string;
  eventType: string;
  userId?: string;
}

const getRequestContext = () => {
  const details: Record<string, unknown> = {};

  if (typeof window !== 'undefined') {
    details.path = window.location.pathname;
    details.search = window.location.search;
  }

  return {
    details,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
  };
};

export const authAuditService = {
  async logEvent(payload: AuthAuditEventPayload): Promise<{ success: boolean; data?: string; error?: string }> {
    try {
      const requestContext = getRequestContext();
      const details = {
        ...requestContext.details,
        ...(payload.details || {}),
      };

      const { data, error } = await supabase.rpc('log_auth_audit_event', {
        p_details: details,
        p_email: payload.email ?? null,
        p_event_type: payload.eventType,
        p_user_agent: requestContext.userAgent,
        p_user_id: payload.userId ?? null,
      });

      if (error) {
        return { success: false, error: error.message };
      }

      return { success: true, data: data ?? undefined };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to log auth audit event',
      };
    }
  },
};
